import React from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ko' ? 'en' : 'ko';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      style={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #2C3E50',
        borderRadius: '6px',
        padding: '6px 5px',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '13px',
        color: '#2C3E50',
        boxShadow: '1px 1px 0px #2C3E50',
        transition: 'all 0.2s',
        fontFamily: 'inherit'
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translate(-1px, -1px)';
        e.currentTarget.style.boxShadow = '3px 3px 0px #2C3E50';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'translate(0, 0)';
        e.currentTarget.style.boxShadow = '2px 2px 0px #2C3E50';
      }}
    >
      {i18n.language === 'ko' ? '🇺🇸 EN' : '🇰🇷 KO'}
    </button>
  );
}

export default LanguageSwitcher;